import preloader from './modules/loader-page';
import sidebar from './modules/sidebar';
import photoGallery from './modules/photo-gallery';
import parallax from './modules/paralaxv2.1.js';
import gallery from './modules/gallery';
import './widget/index.js';
import sharing from './modules/sharing';
import $ from'jquery'
import buttonDown from './modules/buttonDown';
import store from './store/index';

sharing();

function callback() {
	sidebar({
		button: '.sidebar-btn',
		wrapper: '.o-main',
        frame: '.wrapper',
        sidebar: '.o-sidebar',
		scrollbarhide: 'true',
        mobileWidth: store.MOBILE_WIDTH
	});
	parallax.start({
        mobileWidth: store.MOBILE_WIDTH
	});
    gallery.open();
    photoGallery();
}

let loader = new preloader({
	element: '#loader-page',
	callback: callback
});


$('.b-top-menu__visa.open').on('click', () => window.history.back());

buttonDown({
    el: '.button-down',
    scrollEl: '.wrapper'
});


// WEBPACK FOOTER //
// ./article.js